import { createAction } from 'redux-actions';
import types from './types';

export const setUserOriginInfo = createAction(types.SET_USER_ORIGIN_INFO);
export const setAuthorization = createAction(types.SET_AUTHORIZATION);
